import Situation from './Situation';
import TrashOptimizeModal from "./TrashOptimizeModal";

export default class TrashCalculator {
  constructor(wrapper) {
    this.wrapper = document.querySelector(wrapper);
    this.addSituation = this.wrapper.querySelector('#add-simulation');
    this.situations = [];
    this.counters = [];

/*    this.currentSituation = new Situation(document.getElementById('current-situation'));
    this.situations.push(this.currentSituation);

    this.newSituation = new Situation(document.getElementById('new-situation'));
    this.situations.push(this.newSituation);*/

    this.dataText = JSON.parse(this.wrapper.dataset.text);

    this.init();
    this.events();
  }

  init() {
    let situations = this.wrapper.querySelectorAll('.situation-content-wrapper');
    situations.forEach( (situation) => {
      this.situations[situation.dataset.situation] = new Situation(situation, this);
    } );

    let counters = this.wrapper.querySelectorAll('.switch-situation');
    counters.forEach( (counter) => {
      let situation = counter.dataset.situation;
      this.counters[situation] = counter;
    });
    counters[1].style.display = 'none';
  }

  events() {

    document.addEventListener('modalRowUpdate', () => {

    });

    this.addSituation.addEventListener( 'click', (e) => {
      e.preventDefault();
      let firstSituation = this.situations[Object.keys(this.situations)[0]];
      if(Object.keys(firstSituation.modals).length > 0) {
        this.switchSituation(Object.keys(this.situations)[1]);
       this.addOptimizeModal();

        this.addSituation.remove();
        this.wrapper.querySelector('.switch-situation[data-situation="'+ Object.keys(this.situations)[1] +'"]').style.display = 'block';
      } else {
        alert(this.dataText.addTrashWarning);
      }
    } );

    Object.keys(this.counters).forEach( (counter) => {
      this.counters[counter].addEventListener( 'click', (e) => {
        e.preventDefault();
        if(!this.counters[counter].classList.contains('active')) {
          this.switchSituation(this.counters[counter].dataset.situation);
        }
      } );
    } );
  }

  switchSituation(nextSituation) {
    let situations = Object.keys(this.situations);
    if(situations.length > 1) {
      situations.forEach((situation) => {
        if(nextSituation === situation) {
          this.situations[situation].show();
        } else {
          this.situations[situation].hide();
        }
      });
    }

    Object.keys(this.counters).forEach((counter) => {
      if(nextSituation === counter) {
        this.counters[counter].classList.add('active');
      } else {
        this.counters[counter].classList.remove('active');
      }
    });
  }

  async addOptimizeModal(){

    //Get Current
    let newSituation = document.querySelector('[data-situation="current"]');

    let checkboxes = newSituation.querySelectorAll('input[type="checkbox"]');
    let trashes = [];
    for (var i=0; i<checkboxes.length; i++) {
      // And stick the checked ones onto an array...
      if (checkboxes[i].checked) {
        trashes.push(checkboxes[i].value);
      }
    }
    if (trashes.length != 1){
      return null;
    }
    let trash = trashes[0];

    const data = await this.getOptimizeTrashData(trash);
    if (data == 'null'){
      return false;
    }
    this.wrapper.insertAdjacentHTML('beforeend', data);
    let optimizeModalModalWrapper = this.wrapper.querySelector(`.trash-calculator-optimize-form-wrapper`);

    let trashOptimizeModal = new TrashOptimizeModal(optimizeModalModalWrapper);
    trashOptimizeModal.open();
  }

  async getOptimizeTrashData(trash) {
    const response = await fetch(`/api/hygiene/trash/optimize/`+trash);
    return await response.text();
  }

}
